import { Component, Inject, OnInit, Optional, Input} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ModelloCompagnia } from 'src/app/models/modello-compagnia';
import { BaseEditForm } from 'src/app/shared/baseEditForm';
import { HttpClient } from '@angular/common/http';
import { ModelloCompagniaService } from 'src/app/services/modello-compagnia.service'


@Component({
  selector: 'modello-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class ModelloCompagnieFormComponent extends BaseEditForm implements OnInit {

  modello: ModelloCompagnia;
  form: FormGroup;

  nome : string;

  constructor(
    private http: HttpClient,
    private modelloCompagniaService: ModelloCompagniaService,
    private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<ModelloCompagnieFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: ModelloCompagnia,) {
    super();
    this.modello = data;
    if (data && data.nome_file && typeof data.nome_file === 'string') {
      this.nome = data.nome_file.slice(40);
    }
  }

  
  ngOnInit() {
    this.form = this.fb.group({
      compagnia: [this.modello?.compagnia,  Validators.required], 
      nome_condizione: [this.modello?.nome_condizione],
      cod_modello: [this.modello?.cod_modello],
      edizione: [this.modello?.edizione],
      nome_file: [this.modello?.nome_file, null],
    });
  }

}

